import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../Infra/display-name";
import Add from "@mui/icons-material/Add";
import ListItemIcon from "@mui/material/ListItemIcon";
import HXMenuItem from "./HXMenuItem";
import { format } from "date-fns";
import { getFullName } from "healthex-common/utils";
import { NOT_LOADED } from "../Infra/RemoteData";
import { AdminAPIKeyListViewModel } from "./AdminAPIKeyListViewModel";
import { ActionButton, AdminAPIKeysViewParent, AvatarAndName, DestructiveText, EditIcon, IntroAndActionsRow, IntroText, RemoveIcon, } from "./AdminAPIKeysListView.styles";
import { HXButton } from "./HXButton";
import { HXDataGrid } from "./HXDataGrid";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { NoDataCardView } from "./NoDataCardView";
import { UserAvatarView } from "./UserAvatarView";
import { BaseLink } from "./base.styles";
import { useViewModel } from "./useViewModel";
import { HXDialog, HXDialogCloseButton, HXDialogContent, HXDialogHeader, HXDialogTitle } from "./HXDialog";
import { AdminAPIKeyDeleteConfirmationDialog, AdminAPIKeyForm } from "./AdminAPIKeyForm";
import { defaultPageSize } from "healthex-common/constants";
export const AdminAPIKeysListView = observer((props) => {
    var _a;
    const model = useViewModel(AdminAPIKeyListViewModel, props);
    return (_jsxs(AdminAPIKeysViewParent, { children: [model.apiKeys === NOT_LOADED ? (_jsx(LoadingPlaceholder, { w: 10, h: 60 })) : model.total === 0 ? (_jsx(NoDataCardView, { title: "No API keys added", text: "Allow external services to access HealthEx on behalf of a user.", buttons: [
                    {
                        secondary: true,
                        children: "Create API key",
                        onClick: () => model.createAPIKey(),
                        startIcon: _jsx(Add, {}),
                    },
                ] })) : (_jsxs(_Fragment, { children: [_jsxs(IntroAndActionsRow, { children: [_jsxs(IntroText, { children: ["HealthEx makes it simple for developers to build applications and services that support workflow integration, usage and analysis. Use your API key and secret to access HealthEx APIs.", " ", _jsx(BaseLink, { href: "https://docs.healthex.io", children: "View documentation" }), "."] }), _jsx(HXButton, { secondary: true, startIcon: _jsx(Add, {}), onClick: () => model.createAPIKey(), children: "Create API key" })] }), _jsx(HXDataGrid, { rows: model.apiKeys, columns: columns(), getRowId: (user) => user.id, initialState: {
                            sorting: { sortModel: [{ field: "createdAt", sort: "desc" }] },
                        }, rowCount: model.total, paginationModel: { page: model.page, pageSize: defaultPageSize }, onPaginationModelChange: (paginationModel) => model.updatePagination(paginationModel), paginationSelectedLabel: "key" }), model.deleteConfirmationApiKey && (_jsx(AdminAPIKeyDeleteConfirmationDialog, { open: model.deleteConfirmationModel.open, onClose: (choice) => model.deleteConfirmationModel.onChoice(choice), apiKey: model.deleteConfirmationApiKey }))] })), _jsxs(HXDialog, { open: model.apiKeyDialogOpen, onClose: () => model.createOrEditAPIKeyDone(), fullWidth: true, maxWidth: "sm", children: [_jsxs(HXDialogHeader, { children: [_jsx(HXDialogTitle, { id: "alert-dialog-title", children: model.apiKeyToEdit ? "Edit API key" : "Create API key" }), _jsx(HXDialogCloseButton, { onClick: () => model.createOrEditAPIKeyDone() })] }), _jsx(HXDialogContent, { children: _jsx(AdminAPIKeyForm, { container: props.container, onDone: () => model.createOrEditAPIKeyDone(), keyToEdit: (_a = model.apiKeyToEdit) !== null && _a !== void 0 ? _a : undefined }) })] })] }));
    function columns() {
        return [
            { field: "name", headerName: "Name", flex: 1 },
            { field: "apiKey", headerName: "API Key", flex: 1.5, cellClassName: "singleLineEllipis" },
            {
                field: "createdBy",
                headerName: "Created by",
                renderCell: (params) => {
                    if (params.value === undefined)
                        return null;
                    const user = params.value;
                    return (_jsxs(AvatarAndName, { children: [_jsx(UserAvatarView, { user: user }), _jsx("div", { children: user ? getFullName(user) : "Unknown user" })] }));
                },
                flex: 1,
            },
            {
                field: "createdAt",
                headerName: "Created on",
                renderCell: (params) => {
                    if (params.value === undefined)
                        return null;
                    const createdAt = params.value;
                    return format(createdAt, "MM-dd-yyyy");
                },
                flex: 0.5,
            },
            {
                field: "actions",
                headerName: "Actions",
                flex: 0.3,
                sortable: false,
                renderCell: (params) => {
                    const apiKey = params.row;
                    return (_jsxs(ActionButton, { children: [_jsxs(HXMenuItem, { onClick: () => model.editAPIKey(apiKey), children: [_jsx(ListItemIcon, { children: _jsx(EditIcon, {}) }), "Edit API key"] }), _jsxs(HXMenuItem, { onClick: () => model.deleteAPIKey(apiKey), children: [_jsx(ListItemIcon, { children: _jsx(RemoveIcon, {}) }), _jsx(DestructiveText, { children: "Delete API key" })] })] }));
                },
            },
        ];
    }
});
addDisplayName(AdminAPIKeysListView, "AdminAPIListView");
